import { render } from "./DistributorNewOrderPage.vue?vue&type=template&id=028c37ce&scoped=true"
import script from "./DistributorNewOrderPage.vue?vue&type=script&lang=js"
export * from "./DistributorNewOrderPage.vue?vue&type=script&lang=js"

import "./DistributorNewOrderPage.vue?vue&type=style&index=0&id=028c37ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028c37ce"]])

export default __exports__